// API service for Natalia Regina VetClin
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Auth helpers
export const getAuthToken = () => localStorage.getItem('admin_token');
export const setAuthToken = (token) => localStorage.setItem('admin_token', token);
export const removeAuthToken = () => localStorage.removeItem('admin_token');

const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Content API
export const getContent = async () => {
  const response = await axios.get(`${API_BASE}/content`);
  return response.data;
};

export const updateContent = async (content) => {
  const response = await axios.put(
    `${API_BASE}/content`,
    content,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// Appointments API
export const createAppointment = async (appointmentData) => {
  const response = await axios.post(`${API_BASE}/appointments`, appointmentData);
  return response.data;
};

export const getAppointments = async () => {
  const response = await axios.get(`${API_BASE}/appointments`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const updateAppointmentStatus = async (id, status) => {
  const response = await axios.patch(
    `${API_BASE}/appointments/${id}`,
    { status },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const deleteAppointment = async (id) => {
  const response = await axios.delete(`${API_BASE}/appointments/${id}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Auth API
export const login = async (username, password) => {
  const response = await axios.post(`${API_BASE}/auth/login`, {
    username,
    password
  });
  return response.data;
};

// Contact Card API
export const downloadVCard = () => {
  window.open(`${API_BASE}/contact-card/vcard`, '_blank');
};

export const downloadContactCardImage = () => {
  window.open(`${API_BASE}/contact-card/image`, '_blank');
};